module.exports = __webpack_public_path__ + "img/about3.adb5f3f7.png";